import ClipboardIcon from './component.jsx'
export default ClipboardIcon
